"use strict";
/**
 * OpenSearch Collection Search Types
 *
 * Minimal contract interface for the `collections` OpenSearch index family. There is no
 * dedicated collection search-document builder in lambda-utilities (collections are
 * registered/bootstrapped by the setup lambda), so this interface captures exactly the
 * fields the `collections` index template maps: collection_id, owner_identity_id,
 * owner_screen_name, title, description, collection_tags, category, pattern_count,
 * follower_count, is_public, created_at, updated_at.
 *
 * It exists so `COLLECTION_FIELDS` (in `collections-definition.ts`) can be typed
 * `as const satisfies Record<string, keyof CollectionSearchDocument>`, keeping the
 * field-name constants and the contract structurally unable to drift — the same approach
 * used for `UserSearchDocument`/`USER_FIELDS`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
